module.exports = __webpack_public_path__ + "img/gabarito-3.10f240a8.png";